import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import { useAuth0 } from '@auth0/auth0-react'; // Import the useAuth0 hook

const TenantsList = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false); // New error state
  const navigate = useNavigate(); // Initialize the navigate function
  const { getAccessTokenSilently } = useAuth0(); // Destructure to get the access token

  /*
  useEffect(() => {
    const fetchTenants = async () => {
      setLoading(true);
      try {
        const response = await axios.get('https://api.sevis.click/admin/tenants');
        setTenants(response.data);
      } catch (error) {
        console.error('Error fetching tenants:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTenants();
  }, []);
  */

  useEffect(() => {
    const fetchTenants = async () => {
      setLoading(true);
      setError(false); // Reset error state on start
      try {
        // Get the access token
        const token = await getAccessTokenSilently({
          audience: 'https://your-api-endpoint',
          scope: 'openid email profile admin:read:users:all users:read delete:tenants',
        });

        // Fetch tenant details by tenantId
        const tenantResponse = await axios.get(`https://api.sevis.click/admin/tenants`, {
          headers: { Authorization: `Bearer ${token}` }, // Include the access token
        });

        //const tenantData = tenantResponse.data.tenant;
        //setTenant(tenantData);
        setTenants(tenantResponse.data);

      } catch (error) {
        console.error('Error fetching tenants:', error);
        setError(true); // Set error state if something fails
      } finally {
        setLoading(false);
      }
    };

    fetchTenants();
  }, [getAccessTokenSilently]);

  // Function to handle navigation to tenant details
  const handleViewDetails = (tenantId) => {
    navigate(`/tenant/${tenantId}`); // Navigate to the tenant details page
  };

  return (
    <div>
      <h2>All Tenants</h2>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p style={{ color: 'red' }}>Error loading tenants. Please try again later.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Tenant ID</th>
              <th>Customer Name</th>
              <th>Customer Subdomain</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tenants.map((tenant) => (
              <tr key={tenant.tenantId}>
                <td>{tenant.tenantId}</td>
                <td>{tenant.customerName}</td>
                <td>{tenant.customerSubdomain}</td>
                <td>
                  <button onClick={() => handleViewDetails(tenant.tenantId)}>View Details</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TenantsList;
